import { createStructuredSelector } from 'reselect';
import { createSelector } from '@reduxjs/toolkit';
import { extractStencils } from 'shared/product_tabs/tab_stencils/slice/extractor';

export const selectStencils = (state) => state.stencils?.stencils;
export const selectStencilsSide = (state) => state.stencils?.stencilsSide;
export const selectStencilsType = (state) => state.stencils?.stencilsType;
export const selectStencilsParameters = (state) => state.stencils?.stencilsParameters;
export const selectStencilsToBuy = (state) => state.stencils?.stencilsToBuy;
export const selectStencilsDestroy = (state) => state.stencils?.stencilsToDestroy;
export const selectFabricationQuote = (state) => state.stencils?.fabrication_quote;

export const selectStencilsData = createStructuredSelector({
  stencils: selectStencils,
  stencilsSide: selectStencilsSide,
});

export const selectStencilsForValidation = createStructuredSelector({
  stencilsToBuy: selectStencilsToBuy,
  stencilsParameters: selectStencilsParameters,
  stencilsToDestroy: selectStencilsDestroy,
});

export const selectStencilsDataForCart = createSelector([
  selectStencilsToBuy,
  selectStencilsParameters,
  selectStencilsDestroy,
  selectFabricationQuote,
], (
  stencils,
  stencilsParameters,
  stencilsToDestroy,
  fabrication_quote
) => {
  const items_to_destroy = stencilsToDestroy && stencilsToDestroy.length ? stencilsToDestroy : [];
  const stencilDataForForms = stencils && stencils.length ? {
    stencils,
    stencilsParameters,
    fabrication_quote
  } : {};

  return {
    stencilDataForForms,
    stencilsProps: extractStencils({ stencils }),
    stencilsToDestroy: items_to_destroy,
  };
});
